import { WarningLevel, WarningType } from "../../WarningDescription.js";
import { standardWarningDescriptions } from "../../Configurations/WarningConfigurations.js";

export type WarningResolutionState = "absent" | "resolved" | "active";

/**
 * Resolution state of a warning version: whether the warning is active or not. Deliberately
 * ignores warningLevel and content fields — only resolution-state transitions are re-notify
 * events. The single predicate the notification diff reads instead of `deleted` directly,
 * so manual-resolve later becomes a one-line widening here.
 */
export const stateOf = (version: { deleted: boolean } | null | undefined): WarningResolutionState => {
    if (!version) return "absent";
    return version.deleted ? "resolved" : "active";
};

export type WarningFieldsFromType = {
    warningType: WarningType;
    warningTitle: string;
    warningDetails: string;
    warningTypePriority: number;
    warningLevel: WarningLevel;
    SMSSent: boolean;
    seen: boolean;
    warningSourceKey?: string;
};

export const createFromWarningType = (
    warningType: WarningType,
    options: Partial<Omit<WarningFieldsFromType, "SMSSent" | "seen">> = {},
): WarningFieldsFromType => {
    let warningDefaults: Partial<WarningFieldsFromType> = {};
    if (standardWarningDescriptions[warningType]) {
        const defaultInfo = standardWarningDescriptions[warningType];
        warningDefaults = {
            warningTypePriority: defaultInfo.priority,
            warningDetails: defaultInfo.details,
            warningLevel: defaultInfo.possibleWarningLevels[0],
        };
    }

    return {
        warningType: warningType,
        warningTitle: warningType,
        warningDetails: "",
        warningTypePriority: 999,
        warningLevel: WarningLevel.WARNING,
        ...warningDefaults,
        ...options,
        // new warnings are always unseen and unsent
        SMSSent: false,
        seen: false,
    };
};
